import { render, staticRenderFns } from "./UploadDiffDescription.vue?vue&type=template&id=35bc75e5&scoped=true"
import script from "./UploadDiffDescription.vue?vue&type=script&lang=js"
export * from "./UploadDiffDescription.vue?vue&type=script&lang=js"
import style0 from "./UploadDiffDescription.vue?vue&type=style&index=0&id=35bc75e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bc75e5",
  null
  
)

export default component.exports